import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { LiveListingsResponse } from '../domain/listings';

/** Base URL of the live listings API (`backend/src/listingsApi/`); unset = feature off. */
export const LISTINGS_API_URL = process.env.REACT_APP_LISTINGS_API_URL?.replace(/\/+$/, '') ?? '';

/** Current mobile.bg ads for a make/model, fetched live (the API caches each model for ~15 minutes). */
export function useLiveListings(make: string, model: string): UseQueryResult<LiveListingsResponse> {
  return useQuery({
    queryKey: ['liveListings', make, model],
    queryFn: async () => {
      const params = new URLSearchParams({ brand: make, model });
      const response = await fetch(`${LISTINGS_API_URL}/listings?${params}`);
      if (!response.ok) {
        throw new Error(`Listings API answered ${response.status}`);
      }
      return (await response.json()) as LiveListingsResponse;
    },
    enabled: Boolean(LISTINGS_API_URL && make && model),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
